document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('[data-contact-form-type="pre-order"] .form-success');
  var forms = document.querySelectorAll('[data-contact-form-type="pre-order"]');

  forms.forEach(function(wrapper) {
    var submit = wrapper.querySelector('button[type="submit"]');
    if (!submit) return;
    var hasEmail = !!wrapper.querySelector('[data-field-name="email"]');
    submit.disabled = !hasEmail;
    submit.setAttribute('aria-disabled', (!hasEmail).toString());
    wrapper.classList.toggle('pre-order-request--disabled', !hasEmail);
  });

  if (form) {
    var openPopup = function() {
      var popup = form.closest('[id^="PopupModal-"]') || form.closest('side-drawer');
      if (!popup) return;
      if (typeof popup.open === 'function') {
        popup.open();
      } else {
        popup.setAttribute('open', 'true');
      }
      popup.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (
            node.nodeType === 1 &&
            node.classList.contains('form-success')
          ) {
            openPopup();
          }
        });
      });
    });

    observer.observe(form, { childList: true, subtree: true });
    openPopup();
  }

  document.querySelectorAll('side-drawer[id^="PreOrderModal"]').forEach(bindPreOrderDrawerVariantSync);
});

function resolvePreOrderVariantId(drawer) {
  if (!drawer) return '';
  var pending = String(drawer.getAttribute('data-pre-order-pending-variant-id') || '').trim();
  if (pending) return pending;

  var sectionId = drawer.getAttribute('data-pre-order-section-id');
  if (!sectionId) return '';
  var productForm = document.querySelector('#product-form-' + sectionId);
  if (!productForm) return '';
  var variantInput = productForm.querySelector(
    'input[name="id"].product-variant-id, input.product-variant-id[name="id"], input[name="id"]'
  );
  if (!variantInput) return '';
  return String(variantInput.value || '').trim();
}

function syncPreOrderUnavailableVariantSelect(drawer) {
  if (!drawer || !drawer.classList.contains('open')) return;
  var vid = resolvePreOrderVariantId(drawer);
  if (!vid) return;
  var sel = drawer.querySelector('select[name="contact[unavailable_variant]"]');
  if (!sel) return;
  var match = Array.prototype.find.call(sel.options, function(opt) {
    return opt.dataset && String(opt.dataset.variantId || '') === vid;
  });
  if (!match) {
    var suffix = '(ID: ' + vid + ')';
    match = Array.prototype.find.call(sel.options, function(opt) {
      return opt.value && opt.value.indexOf(suffix) !== -1;
    });
  }
  if (!match) return;
  if (sel.value !== match.value) {
    sel.value = match.value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  drawer.removeAttribute('data-pre-order-pending-variant-id');
}

function bindPreOrderDrawerVariantSync(drawer) {
  if (!drawer || drawer.dataset.preOrderVariantSyncBound === 'true') return;
  drawer.dataset.preOrderVariantSyncBound = 'true';
  var obs = new MutationObserver(function() {
    if (drawer.classList.contains('open')) {
      requestAnimationFrame(function() {
        syncPreOrderUnavailableVariantSelect(drawer);
      });
    }
  });
  obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
}

window.syncPreOrderUnavailableVariantSelect = syncPreOrderUnavailableVariantSelect;
